<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'中介服务管理'},{name:'中介服务列表',goback:true},{name:'编辑中介服务'}]" :title="'编辑中介服务'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>中介服务名称：</div>
                        <el-input v-model="sendInfo.name" maxlength="20"></el-input>
                    </div>
                    <div class="error" v-if="errors['sendInfo.name']">错误提示：{{errors['sendInfo.name']}}</div>

                    <div class="child">
                        <div class="name"><span>*</span>服务类型：</div>
                        <el-select v-model="sendInfo.serviceType" placeholder="请选择">
                            <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.dictName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="error" v-if="errors['sendInfo.serviceType']">错误提示：{{errors['sendInfo.serviceType']}}</div>

                    
					<div class="child">
					    <div class="name"><span>*</span>联系人：</div>
					    <el-input v-model="sendInfo.contactPerson" maxlength="30"></el-input>
					</div>
					<div class="error" v-if="errors['sendInfo.contactPerson']">错误提示：{{errors['sendInfo.contactPerson']}}</div>
					
					<div class="child">
					    <div class="name"><span>*</span>联系电话：</div>
					    <el-input v-model="sendInfo.contactNumber" maxlength="16"></el-input>
					</div>
					<div class="error" v-if="errors['sendInfo.contactNumber']">错误提示：{{errors['sendInfo.contactNumber']}}</div>
					
                    <div class="child">
                        <div class="name">网址链接：</div>
                        <el-input v-model="sendInfo.websiteLink"></el-input>
                    </div>
					<div class="hint">请输入http://或https://开头的网址</div>
                    <div class="error" v-if="errors['sendInfo.websiteLink']">错误提示：{{errors['sendInfo.websiteLink']}}</div>
					<div class="child">
					    <div class="name"><span>*</span>简介：</div>
					    <div class="content"><el-input type="textarea" v-model="sendInfo.summary" show-word-limit maxlength="200"></el-input></div>
					</div>
					<div class="error" v-if="errors['sendInfo.summary']">错误提示：{{errors['sendInfo.summary']}}</div>
					
                    <div class="child">
                        <div class="name"><span>*</span>LOGO：</div>
                        <div class="content"><upLoad 
						:action="'backstage/annex/file'" 
						:accept="'image/png,image/jpg,image/jpeg'" 
						:size="20"
            is-need-limit
            :sizeList="[1 / 1]"
            :fixedNumber='[1,1]'
            :autoCropWidth="200"
            :autoCropHeight='200'
					            	v-model="sendInfo.logo"/>
						            </div>
                    </div>
                    <div class="hint">图片仅支持png、jpg，建议高宽比为1:1，尺寸建议200*200px，大小不超过20M</div>
                    <div class="error" v-if="errors['sendInfo.logo']">错误提示：{{errors['sendInfo.logo']}}</div>

                    <div class="singleBtn">
                      <el-button type="primary" size="small" @click="submit">提交审核并发布</el-button>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import upLoad from '../../components/upLoads'
import {getDict} from "@/axios";
export default {
    components:{
        breadcrumb,
        upLoad
    },
    data(){
        return{
            statusList: [],//服务类型
			id:'',
            sendInfo:{
                "intermediaryServiceId":this.$route.query.id ? this.$route.query.id  : null,//中介服务ID，编辑时必传
                "logo": null,
                "name": null,//中介服务名称
                "serviceType": null,//服务类型
                "summary": null,//简介
                "websiteLink": null,//网址链接
				contactPerson:null,//联系人
				contactNumber:null,//联系人电话
            },
			dict:{
				currentPage:1,
				direction:null,
				pageSize:10,
				parentId :1069409909080064,
				property:null,
			}
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
	created() {
		// /backstage/sysDict/parentId
		this.$axiosz.get('/rpc/sysDict/parentId/1069409909080064').then(res=>{
		    if(res.code==200){
				this.statusList=res.data
		    }else{
		        this.$alert(res.msg)
		    }
		})
		if(this.$route.query.id){
		    this.id=this.$route.query.id;
			this.sendInfo.intermediaryServiceId=this.$route.query.id;
			this.getDetail();
		}
		
	},
    vuerify: {
		'sendInfo.contactPerson':{
		    test:function(){
		        if(this.sendInfo.contactPerson){
		            return true;
		        }else{
		            return false;
		        }
		    },
		    message:'填写联系人'
		},
		'sendInfo.contactNumber':{
		    test:function(){
		        if(this.sendInfo.contactNumber){
		            return true;
		        }else{
		            return false;
		        }
		    },
		    message:'填写联系电话'
		},
        'sendInfo.name':{
            test:function(){
                if(this.sendInfo.name){
                    return true;
                }else{
                    return false;
                }
            },
            message:'填写中介服务名称'
        },
        'sendInfo.serviceType':{
            test:function(){
                if(this.sendInfo.serviceType){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择服务类型'
        },
        'sendInfo.summary':{
            test:function(){
                if(this.sendInfo.summary){
                    return true;
                }else{
                    return false;
                }
            },
            message:'填写简介'
        },
    //     'sendInfo.websiteLink':{
    //         test:function(){
				// // ^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?
    //             if(this.sendInfo.websiteLink){
    //                 return true;
    //             }else{
    //                 return false;
    //             }
    //         },
    //         message:'填写网址链接'
    //     },
        'sendInfo.logo':{
            test:function(){
                if(this.sendInfo.logo){
                    return true;
                }else{
                    return false;
                }
            },
            message:'上传LOGO'
        },
    },
    methods:{
		getDetail(){
			this.$axiosc.get('backstage/intermediary/details/'+this.id).then((r)=>{
			    if(r.code==200){
			        this.dataInfo=r.data;
					let	sendInfo={
					    "intermediaryServiceId": r.data.id,//中介服务ID，编辑时必传
					    "logo": r.data.logo,
					    "name": r.data.name,//中介服务名称
					    "serviceType": r.data.serviceType,//服务类型
					    "summary": r.data.summary,//简介
					    "websiteLink": r.data.websiteLink,//网址链接
						contactPerson:r.data.contactPerson,//联系人
						contactNumber:r.data.contactNumber,//联系人电话
					}
					this.sendInfo=sendInfo;
			    }else{
			        this.$alert(r.msg)
			    }
			})
		},
        //提交
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
				this.$axioscBody.post('/backstage/intermediary/saveIntermediary',this.sendInfo).then((r)=>{
					if(r.code==200){
						this.$message({
							type: 'success',
							message: r.msg
						});
						this.$router.back();
					}else{
						this.$alert(r.msg);
					}
				})
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.warp{
     height:96%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        padding-top: 20px;
        border-top:1px solid rgba(112, 112, 112, 0.1);
        .forms{
            max-width: 450px;
            margin: auto;
            .child{
                .content{
                    flex: 1;
					.el-textarea{
						width: 100% !important;
					}
                }
				/deep/ .el-select{
					width: 100% !important;
				}
				
				.name{
					width: 150px !important;
					text-align: right;
				}
            }
			.hint{
				padding-left: 100px;
			}
			.singleBtn{
				text-align: center;
			}
			.error{
				padding-left: 100px;
			}
        }
    }
}
</style>